import CircleIcon from "@mui/icons-material/Circle";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const StyledSwitch = styled(Switch)(({ theme }) => ({
  height: 28,
  width: 42,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 4,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(14px)",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    "& + .MuiSwitch-track": {
      borderRadius: 28 / 2,
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

function SwitchIcon({ checked, icon: Icon }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <CircleIcon
        color={checked ? "secondary" : "primary"}
        sx={{ fontSize: "28px", position: "absolute", zIndex: -1 }}
      />
      <Icon color="backgroundContrast" fontSize="small" />
    </Box>
  );
}

export default function CustomSwitch({
  checked,
  checkedIcon: CheckedIcon,
  handleChange,
  icon: Icon,
}) {
  return (
    <StyledSwitch
      checked={checked}
      onChange={handleChange}
      icon={<SwitchIcon checked={checked} icon={Icon} />}
      checkedIcon={<SwitchIcon checked={checked} icon={CheckedIcon} />}
      sx={{ my: { xs: 0.5 }, mx: { sm: 1 } }}
    />
  );
}
